import { useEffect, useRef, useCallback } from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import EmployeePortal from './components/EmployeePortal';
import { appInsightsInstance } from './index';

const MainContent = () => {
    const { instance, accounts } = useMsal();
    const timeoutRef = useRef(null);

    // ⏰ Funkce pro odhlášení uživatele
    const logoutUser = useCallback(() => {
        console.log('User inactive for 2 minutes. Logging out.');
        appInsightsInstance.trackEvent({ name: 'AutoLogoutDueToInactivity' });
        instance.logoutRedirect();
    }, [instance]);

    // 🔄 Funkce pro restartování timeru (zabalená do useCallback)
    const resetTimer = useCallback(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(logoutUser, 5 * 60 * 1000); // 5 minuty
    }, [logoutUser]);

    // 🧠 Přidání listenerů pro sledování aktivity
    useEffect(() => {
        if (accounts.length) {
            const activityEvents = ['mousemove', 'keydown', 'scroll', 'touchstart'];
            activityEvents.forEach(event =>
                window.addEventListener(event, resetTimer)
            );
            resetTimer(); // Spuštění počátečního timeru

            return () => {
                activityEvents.forEach(event =>
                    window.removeEventListener(event, resetTimer)
                );
                clearTimeout(timeoutRef.current);
            };
        }
    }, [accounts, resetTimer]);

    // 🔐 Login řešení
    useEffect(() => {
        if (!accounts.length) {
            instance.handleRedirectPromise().then((response) => {
                if (!response && !accounts.length) {
                    instance.loginRedirect({
                        scopes: ["User.Read"]
                    });
                }
            }).catch((error) => {
                console.error("Error during login", error);
                appInsightsInstance.trackException({
                    error: error,
                    properties: {
                        name: 'LoginError',
                        source: 'loginRedirect'
                    }
                });
            });
        } else {
            const user = accounts[0];
            appInsightsInstance.trackEvent({
                name: 'UserLoggedIn',
                properties: {
                    userId: user.username,
                    tenantId: user.tenantId,
                    accountId: user.localAccountId,
                    environment: process.env.NODE_ENV,
                    timeStamp: new Date().toISOString()
                }
            });

            appInsightsInstance.setAuthenticatedUserContext(
                user.username,
                user.tenantId,
                true
            );
        }
    }, [accounts, instance]);

    return (
        <div className="App">
            <AuthenticatedTemplate>
                <EmployeePortal />
            </AuthenticatedTemplate>

            <UnauthenticatedTemplate>
                {/* <h5 className="card-title">Please sign-in to see your profile information.</h5> */}
            </UnauthenticatedTemplate>
        </div>
    );
};

export default function App() {
    return <MainContent />;
}
